import { FAQ } from '@/components/FAQAccordion/types';
export const defaultFeedbackOptions = [
  { label: '51-200', value: '51-200', id: 3 },
  { label: '201-3,000', value: '201-3,000', id: 4 },
  { label: '3,001-10,000', value: '3,001-10,000', id: 5 },
  { label: '10,001-30,000', value: '10,001-30,000', id: 6 },
  { label: '30,001+', value: '30,001+', id: 7 },
] as const;

export const oldFeedbackOptions = [
  { label: '1-50', value: '1-50', id: 1 },
  ...defaultFeedbackOptions,
] as const;

export const newFeedbackOptions = [
  { label: '1-10', value: '1-10', id: 1 },
  { label: '11-50', value: '11-50', id: 2 },
  ...defaultFeedbackOptions,
] as const;

export enum sizeOfPortfolio {
  oneToFifty = '1-50',
  oneToTen = '1-10',
  elevenToFifty = '11-50',
  fiftyOneToTwoHundred = '51-200',
  TwoHundredOneToThreeThousand = '201-3,000',
  ThreeThousandOneTotenThousand = '3,001-10,000',
  TenThousandOneToThirtyThousand = '10,001-30,000',
  ThirtyThousandOneAndMore = '30,001+',
}
export const basicOptions = [{ label: '1-50', value: '1-50', id: 1 }] as const;

export enum sizeOfPortfolioBasic {
  oneToFifty = '1-50',
}

//use for alan data to store in hubspot with correct size range.
export const getCorrectRangeForSizeOfPortfolio = (number: number) => {
  let result = '';
  switch (true) {
    case number >= 0 && number <= 10:
      result = sizeOfPortfolio.oneToTen;
      break;
    case number >= 11 && number <= 50:
      result = sizeOfPortfolio.elevenToFifty;
      break;

    case number >= 51 && number <= 200:
      result = sizeOfPortfolio.fiftyOneToTwoHundred;
      break;
    case number >= 201 && number <= 3000:
      result = sizeOfPortfolio.TwoHundredOneToThreeThousand;
      break;
    case number >= 3001 && number <= 10000:
      result = sizeOfPortfolio.ThreeThousandOneTotenThousand;
      break;
    case number >= 10001 && number <= 30000:
      result = sizeOfPortfolio.TenThousandOneToThirtyThousand;
      break;
    case number >= 30001:
      result = sizeOfPortfolio.ThirtyThousandOneAndMore;
      break;
  }
  return result;
};

export const SmbFaqs: FAQ[] = [
  {
    question: 'What is Rent Coverage?',
    isExpandedOnLoad: true, // This will be expanded by default
    answer:
      'Our Rent Coverage opens doors to renters by eliminating the risk of default for operators. Rent Coverage is an insurance policy: if a renter defaults on their lease, Rent Coverage covers operators for the missed rent. This way, operators can lease with confidence and renters can access the home of their dreams.',
  },
  {
    question: 'Who usually needs Rent Coverage?',
    answer:
      'Renters who do not meet your usual financial requirements to qualify for a lease. They may be self-employed, a recent graduate, actively seeking work, someone with a lower credit score, an international resident, or anyone that has an atypical or hard to evaluate credit profile. We also cover corporate leases and other exceptional circumstances, which we evaluate on a case by case basis.',
  },
  {
    question: 'What does it cost?',
    answer:
      'Generally, it will cost between 24% to 130% of one months rent, depending on the renter’s credit score, the amount of coverage you select, and what is permissible in your state. It is also proportional to the monthly rent. The cost is per lease, not per renter, so roommates can share the cost.',
  },
  {
    question: 'What does Deposit Coverage actually cover?',
    answer:
      'Everything that a traditional security deposit would cover (including missed rent, legal fees, unpaid utilities, amenities, etc.). Claims are capped at the coverage limit requested. Our Deposit Coverage is active for the life of tenancy as long as the renter stays in the same apartment complex. If a renter purchases a bond in year 1 of their lease, the coverage is still active if they move out after 4 years, for example. This also means renters never have to renew their Deposit Coverage policy.',
  },
  {
    question: 'Who pays for Rent Coverage?',
    answer:
      'Renters do. The price is determined after underwriting in accordance with rates filed and approved by the regulators. Our Rent Coverage is a type of insurance policy that covers someone (the landlord) other than the person who buys it (the renter).',
  },
];
